import React from 'react';
import { SquareCheck, Sun, Ban, Zap, BatteryCharging, ChartColumn } from 'lucide-react';
import '../styles/Calculator.css';

// "Conseils d'utilisation" box from the client's 12KWH report. The report
// quotes the inverter size (kVA) and the day/evening split of production;
// packs don't carry that data yet, so those lines stay generic.
const UsageTips = ({ production }) => {
  const productionKwh = (production / 1000).toLocaleString(undefined, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  });

  return (
    <section className="usage-tips">
      <h6 className="usage-tips__title">
        <SquareCheck size={16} aria-hidden="true" />
        Conseils d'utilisation
      </h6>
      <ul className="usage-tips__list">
        <li>
          <Sun size={15} className="usage-tips__icon" aria-hidden="true" />
          <span>
            <strong>Utilisation optimale :</strong> Privilégiez l'utilisation des appareils à forte
            puissance pendant la journée, lorsque la production solaire est disponible.
          </span>
        </li>
        <li>
          <Ban size={15} className="usage-tips__icon" aria-hidden="true" />
          <span>
            <strong>Gestion de la puissance :</strong> Évitez d'utiliser simultanément plusieurs
            appareils à forte puissance afin de ne pas dépasser la capacité de l'onduleur de votre pack.
          </span>
        </li>
        <li>
          <Zap size={15} className="usage-tips__icon" aria-hidden="true" />
          <span>
            <strong>Classe énergétique de vos appareils :</strong> Privilégiez les appareils à basse
            consommation afin de réduire votre consommation d'énergie et d'optimiser l'autonomie du
            système solaire.
          </span>
        </li>
        <li>
          <BatteryCharging size={15} className="usage-tips__icon" aria-hidden="true" />
          <span>
            <strong>Autonomie :</strong> La production solaire moyenne est estimée
            à <strong>{productionKwh} kWh/jour</strong>, utilisable directement en journée grâce aux
            panneaux solaires et en soirée grâce à la batterie.
          </span>
        </li>
        <li>
          <ChartColumn size={15} className="usage-tips__icon" aria-hidden="true" />
          <span>
            <strong>Variation de la production :</strong> La production solaire peut varier en fonction
            du <strong>lieu d'installation, de l'ensoleillement, de la météo, de l'orientation et de
            l'inclinaison des panneaux</strong>, ainsi que des conditions d'utilisation.
          </span>
        </li>
      </ul>
    </section>
  );
};

export default UsageTips;
